export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.47 6.47a.75.75 0 011.06 0l5 5a.75.75 0 01-1.06 1.06l-5-5a.75.75 0 010-1.06z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.53 11.47a.75.75 0 010 1.06l-5 5a.75.75 0 01-1.06-1.06l5-5a.75.75 0 011.06 0zM11.47 6.47a.75.75 0 011.06 0l5 5a.75.75 0 01-1.06 1.06l-5-5a.75.75 0 010-1.06z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.53 11.47a.75.75 0 010 1.06l-5 5a.75.75 0 11-1.06-1.06l5-5a.75.75 0 011.06 0z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};